import { useCallback, useState } from 'react';
import { isEmpty } from 'lodash-es';

/**
 * エラーをReactにキャッチさせるために、setStateのコールバックの中でエラーを投げるようにするhooks
 * 参考:
 * https://github.com/facebook/react/issues/14981#issuecomment-468460187
 */
export const useThrowError = () => {
  const [, setStateForErrorBoundary] = useState();

  const throwError = useCallback((error: unknown) => {
    setStateForErrorBoundary(() => {
      if (isEmpty(error)) {
        throw new Error();
      }
      throw error;
    });
  }, []);

  return {
    throwError,
  };
};
